export default "__VITE_ASSET__2853624c__"